const TILE_CLASS_SELECTOR = ".product-item";
const TILE_SWIPER_CONFIG = {};

const initCardSwiper = (parent = document) => {
  if (!parent) {
    console.error(`[ERR] Cannot find parent`, parent);
    return;
  }

  parent
    .querySelectorAll(`${TILE_CLASS_SELECTOR} .product-item__images .swiper`)
    .forEach((tileSwiper) => {
      if (tileSwiper.classList.contains("initialized")) {
        return;
      }

      const swiper = new Swiper(tileSwiper, {
        direction: "horizontal",
        loop: false,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      tileSwiper.classList.add("initialized");
    });
};
window.initCardSwiper = initCardSwiper;

const initPdpGallery = () => {
  setTimeout(() => {
    const galleryWrapper = document.querySelector(
      ".product-page-wrapper .product__media-container",
    );
    if (!galleryWrapper) {
      return;
    }
    const galleryNode = galleryWrapper.querySelector(".flickity-slider");
    if (!galleryNode) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target.classList.contains("media-wrapper") &&
          mutation.target.classList.contains("is-selected")
        ) {
          const mediaId = mutation.target.getAttribute("data-media-id");
          const pageToActivate = galleryWrapper.querySelector(
            `.product__media-page[data-media-id="${mediaId}"]:not(.active)`,
          );
          if (pageToActivate) {
            galleryWrapper
              .querySelectorAll(
                `.product__media-page:not([data-media-id="${mediaId}"])`,
              )
              .forEach((wrongNode) => {
                wrongNode.classList.remove("active");
              });
            pageToActivate.classList.add("active");
          }
        }
      });
    });

    observer.observe(galleryNode, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"],
      subtree: true,
    });
  }, 1000);
};
window.initPdpGallery = initPdpGallery;

const initPdpOptions = () => {
  document
    .querySelectorAll(".custom-options-element__values input[type='radio']")
    .forEach((radioOption) => {
      const wrapper = radioOption.closest(".product-form__controls-group");
      if (!wrapper) return;

      const select = wrapper.querySelector(
        `select[name="${radioOption.getAttribute("data-select-name")}"]`,
      );
      if (!select) return;

      radioOption.addEventListener("change", () => {
        select.value = radioOption.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
};
window.initPdpOptions = initPdpOptions;

const initStickyButton = () => {
  const loadingClass = "bttn--loading";
  const buttonId = "pdp-buy-button";
  const realButton = document.querySelector(`#${buttonId}`);
  const buttonLabel = document.querySelector(`label[for="${buttonId}"]`);

  if (!realButton || !buttonLabel) {
    return;
  }

  const buttonWrapper = buttonLabel.closest(".sticky-button__wrapper");
  if (!buttonWrapper) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes") {
        if (mutation.target.classList.contains(loadingClass)) {
          buttonLabel.classList.add(loadingClass);
        } else {
          buttonLabel.classList.remove(loadingClass);
        }

        if (!!mutation.target.getAttribute("disabled")) {
          buttonLabel.setAttribute("disabled", "disabled");
        } else {
          buttonLabel.removeAttribute("disabled");
        }
      }
    });
  });

  observer.observe(realButton, {
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ["class", "disabled"],
    subtree: false,
  });

  const intersectionObserver = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        buttonWrapper.classList.remove("visible");
      } else {
        buttonWrapper.classList.add("visible");
      }
    },
    {
      threshold: 0.15,
    },
  );
  intersectionObserver.observe(realButton);

  const footerSection = document.querySelector(
    ".shopify-section.shopify-section-group-footer-group",
  );
  const buttonWrapperInner = buttonLabel.closest(".sticky-button__inner");
  if (!footerSection || !buttonWrapperInner) {
    return;
  }

  footerSection.style.paddingBottom = `${buttonWrapperInner.clientHeight}px`;
};
window.initStickyButton = initStickyButton;

const init = () => {
  initCardSwiper();
  initPdpGallery();
  initPdpOptions();
  initStickyButton();
};

window.addEventListener("DOMContentLoaded", () => {
  init();
});
